import styled from 'styled-components';

export const WrapperDivsTables = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow-x: auto;
`;

export const TableBase = styled.div`
  border-collapse: collapse;
  th,
  td {
    font-size: 14px;
    font-weight: 300;
    padding: 2px;
    text-align: right;
    border: 1px solid black;
    input {
      width: 80px;
    }
  }
  th {
    text-align: center;
  }
  .NoBorder {
    border: none;
  }
  .SeparateBottom {
    margin-bottom: 3px;
  }
  .SeparateRight {
    margin-right: 3px;
  }
  .Blue {
    background-color: #538dd5;
    color: white;
  }
  .LightBlue {
    background-color: #dce6f1;
  }
  .Gray {
    background-color: #c0c0c0;
  }
  .Green {
    background-color: #d8e4bc;
  }
  .Yellow {
    background-color: #ffff99;
  }
`;
